import { render, staticRenderFns } from "./ProductsWebsiteShopify.vue?vue&type=template&id=52df2c4c&scoped=true&"
import script from "./ProductsWebsiteShopify.vue?vue&type=script&lang=js&"
export * from "./ProductsWebsiteShopify.vue?vue&type=script&lang=js&"
import style0 from "./ProductsWebsiteShopify.vue?vue&type=style&index=0&id=52df2c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52df2c4c",
  null
  
)

export default component.exports